import { useContext, useEffect,useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Container, Grid, LinearProgress, Stack, Typography } from "@mui/material";
import { CasUserContext } from "../../services/casUserContext";
import { TblProductoProdTermin, setProductoTerminado } from "../../interfaces/TblProductoProdTermin";
import { ProductoColaboradorDTO, setListProductoColaborador } from "../../interfaces/ColaboradorProdcutoDTO";
import { TblDecInvMotivoProdTermin, setProductoMotivo } from "../../interfaces/TblDecInvMotivoProdTermin";
import ProductoService from "../../services/ProductoService";
import UsuarioService from "../../services/UsuarioService";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import EmailService from "../../services/EmailService";
import EventoService from "../../services/EventoService";
import { IoIosPricetag } from "react-icons/io";
import { MdDoNotDisturbAlt } from "react-icons/md";
import { AdjuntarProductoDTO, getVoidAdjuntarProductoDTO, setAdjuntarProductoDTO } from "../../interfaces/ProductosDTOS/AdjuntarProyectoDTO";
import AdjuntarProyForm from "../../componentes/Productos/AdjuntarProyectoForm";
import CatalogService from "../../services/CatalogService";
import { TipoProductoDTO } from "../../interfaces/TipoProductoDTO";
import { EmailProductoCreado, setEmailProductoCreado } from "../../interfaces/MailModel";
import { GetProyectoEvntDTO } from "../../interfaces/ProyectosDTOS/EventoProyDTO";
import { GetEvntAdjuntarProyectoDTO } from "../../interfaces/ProyectosDTOS/EvntAdjuntoProyectoDTO";

const productoService = new ProductoService();
const usuarioService = new UsuarioService();
const emailService = new EmailService();
const eventoService = new EventoService();
const catalogoService = new CatalogService();

export const FormAdjProyectoPage: React.FC<{}> = () =>{
    //Seccion variables
    let {id} = useParams();
    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
    const idpersona = casUserContext.userData.idpersona;
    const user = casUserContext.userData;
    const [ready,setReady] = useState(false);
    const [datosFormulario,setDatosFormulario] = useState<AdjuntarProductoDTO>(()=> getVoidAdjuntarProductoDTO());
    const[auth,setAuth] = useState(false);
    const[puedoAdjuntar,setPuedoAdjuntar] = useState(false);
    const [tipoProductos,setTipoProductos] = useState<Array<TipoProductoDTO>>([])
    const [idcreador,setIdcreador] = useState(0)
    let history = useNavigate();
    //#region Seccion de carga
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        //console.log(user);
        setAuth(flag);
        if(flag){  
          fetchData();
        }
    },[]);
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        //console.log(user);
        setAuth(flag);
        if(flag){  
          fetchData();
        }
    },[token]);
    //#endregion
    //#region Funciones
    const fetchData = async () =>{
        try{
            await catalogoService.obtenerAllTipoProducto()
            .then((data) => {
               setTipoProductos(data.listData)
               //console.log(data.objDatos)
            })
            .catch((error) => console.error(error)) 
            await productoService.GetAdjuntarProductoById(parseInt(id || '0'),token)
             .then((data) => {
                //console.log(data.data);
                setProductoParaAdjuntar(data)
             })               
             .catch((error) => console.error(error));                       
        }catch(error){
          console.error('Error:',error);
        }
    };
    function setProductoParaAdjuntar(data: any) {
        //console.log(data);
        setDatosFormulario({
            ...datosFormulario,
            producto: setProductoTerminado(data.data.producto) as TblProductoProdTermin,
            motivo: setProductoMotivo(data.data.motivo) as TblDecInvMotivoProdTermin,
            colProducto: setListProductoColaborador(data.data.colProducto) as Array<ProductoColaboradorDTO>,
            idUsuarioAdjun: user.idinv
        });
        tengoAcceso(data.data.motivo.idpersona);
        setReady(true);
    }
    const goToNavigation = (site:string) =>{
        history(site)
    }
    function tengoAcceso(idmotivocrea:number) {
        let idinvestigador:number = user.idpersona;
        if(usuarioService.authorizedByRol(144,user.roles) || usuarioService.authorizedByRol(142,user.roles)){
        //if(roles.includes('ANALISTA DE GESTIÓN DE PROYECTOS') || roles.includes('ADMINISTRADOR')){
            setPuedoAdjuntar(true);
            setIdcreador(idmotivocrea);
        }else if(idmotivocrea === idinvestigador){
            setPuedoAdjuntar(true);
            setIdcreador(idinvestigador);
        }
    }
    //#endregion
    //#region Interaccion
    const handleResponse = async (responseData: AdjuntarProductoDTO) => {
        // Manejar la respuesta aquí
        //console.log(responseData);
        if(responseData.producto.iddecinvproyecto > 0){
            var evnt = GetProyectoEvntDTO(responseData.producto.iddecinvproyecto,user.idinv,responseData.producto.iddecinvtipoproductoesperado,"SE ADJUNTO","","");
            var evntAdj = GetEvntAdjuntarProyectoDTO(evnt,responseData.producto.titulo); 
            const respE = await eventoService.GuardarEventoProductoAdjuntado(evntAdj,token);
            if(respE.status.isSuccessfully){
                //console.log(respE.data);
                const resp = await emailService.MailProductoAdjuntado(respE.data,token);
            }            
        }
        goToNavigation('/Producto/MisProductos');
    };   
    //#endregion
    return(
        <Container sx={{mt:2, mb:4}}>
            <br />
            {auth ? 
            <>{ready ? 
            <Grid>
                <Alert icon={<IoIosPricetag fontSize="inherit" />} severity="info">
                    <Typography variant="subtitle1" gutterBottom><strong>{datosFormulario.producto.titulo}</strong></Typography>
                </Alert> 
                <br />               
                {puedoAdjuntar 
                ?
                <AdjuntarProyForm productoDTO={datosFormulario} idinvestigador={idcreador} token={user.token} tipoProductos={tipoProductos} onResponse={handleResponse} />
                :
                <Alert icon={<MdDoNotDisturbAlt fontSize="inherit" />} severity="error">
                    <Typography variant="subtitle1" gutterBottom>Lo sentimos, actualmente no tienes acceso a esta opción. Por favor, ponte en contacto con el administrador del sistema para obtener más información o para solicitar permisos adicionales.</Typography>
                </Alert> 
                }
            </Grid>
            :
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                <LinearProgress color="secondary" />
            </Stack>}
          </>
          :
          <UnauthorizedPage />
          }
        </Container>
    );
}

